import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { PROJECT, TrackingPage, ReplaceItemTrackingEvent, TrackingEventName, TrackingEventCategory } from "./tracking";

interface ReplaceItemFunctionArgs {
  readonly replaceFor: string;
}
interface ReplaceItemFunction {
  (args: ReplaceItemFunctionArgs): void;
}

interface UseTrackReplaceItemFunctionArgs {
  readonly page: TrackingPage;
  readonly country: Country;
  readonly segment: Segment;
  readonly checkoutId: string | undefined;
  readonly checkoutItemId: string;
  readonly productVariantId: string;
  readonly tradename: Tradename;
}
interface UseTrackReplaceItemFunction {
  (agrs: UseTrackReplaceItemFunctionArgs): ReplaceItemFunction;
}

const useTrackReplaceItem: UseTrackReplaceItemFunction = ({
  page,
  country,
  segment,
  checkoutId,
  checkoutItemId,
  productVariantId,
  tradename,
}) => {
  const emitUserEvent = useEmitUserEvent<ReplaceItemTrackingEvent>();

  const replaceItem: ReplaceItemFunction = useCallback(
    ({ replaceFor }) => {
      if (!checkoutId) {
        return;
      }

      const replaceItemTrackingEvent: ReplaceItemTrackingEvent = {
        event: TrackingEventName.REPLACE_ITEM,
        eventCategory: TrackingEventCategory.NAVIGATION,
        section: `${PROJECT}_${page}`,
        store: country,
        segment,
        checkoutId,
        checkoutItemId,
        productVariantId,
        tradename,
        replaceFor,
      };

      emitUserEvent(replaceItemTrackingEvent);
    },
    [checkoutId, checkoutItemId, country, emitUserEvent, page, productVariantId, tradename, segment],
  );

  return replaceItem;
};

export { useTrackReplaceItem };
